import type { TagDescription } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { config } from 'config';
import { GeneralApiTagTypes, GeneralApiTagTypesArray } from 'core/api';
import { attachmentsApi } from 'core/attachments/api';

import { TAttachmentUpdateRequestBody, TAttachmentUpdateResponseBody } from '../types';

const updateAttachmentApi = attachmentsApi.injectEndpoints({
    endpoints: (builder) => ({
        updateAttachment: builder.mutation<TAttachmentUpdateResponseBody, TAttachmentUpdateRequestBody>({
            query: ({ attachmentId, ...rest }) => {
                return {
                    url: config.api.endpoints.attachments.update.replace(':id', attachmentId.toString()),
                    method: 'PUT',
                    body: {
                        ...rest,
                    },
                };
            },
            onQueryStarted: async ({ attachmentId, name, sent, type }, { dispatch, queryFulfilled, getState }) => {
                const queries = attachmentsApi.util.selectInvalidatedBy(getState(), [
                    GeneralApiTagTypes.attachment.item,
                ]);

                const patches: { undo: () => void }[] = [];
                for (const { endpointName, originalArgs } of queries) {
                    if (endpointName !== 'getAttachment') continue;

                    const patch = dispatch(
                        attachmentsApi.util.updateQueryData('getAttachment', originalArgs, (draft) => {
                            if (draft.attachment_id !== attachmentId) return;
                            sent !== undefined && (draft.sent = sent);
                            name !== undefined && (draft.name = name);
                            type !== undefined && (draft.type = type);
                        }),
                    );
                    patches.push(patch);
                }

                try {
                    await queryFulfilled;
                } catch (error) {
                    patches.forEach((patch) => patch.undo());
                }
            },
            invalidatesTags: (_res, error, { invoiceId, commissionId }) => {
                const tags: TagDescription<(typeof GeneralApiTagTypesArray)[number]>[] = [];
                if (error) return [];
                if (invoiceId || commissionId) {
                    tags.push({ type: GeneralApiTagTypes.attachment.item });
                }
                tags.push({ type: GeneralApiTagTypes.attachment.list }, { type: GeneralApiTagTypes.commission.list });
                return tags;
            },
        }),
    }),
});

export const { useUpdateAttachmentMutation } = updateAttachmentApi;
